(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.NBBWelcomeScratch = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  function alphaRatio(imageData, sampleStep) {
    if (!imageData || !imageData.width || !imageData.height || !imageData.data) return 0;
    var step = Math.max(1, Math.floor(Number(sampleStep) || 1));
    var sampled = 0;
    var erased = 0;
    for (var y = 0; y < imageData.height; y += step) {
      for (var x = 0; x < imageData.width; x += step) {
        sampled += 1;
        if (imageData.data[(y * imageData.width + x) * 4 + 3] < 128) erased += 1;
      }
    }
    return sampled ? erased / sampled : 0;
  }

  function create(canvas, options) {
    if (!canvas || typeof canvas.getContext !== 'function') throw new Error('Scratch canvas is required');
    options = options || {};
    var doc = canvas.ownerDocument;
    var win = doc && doc.defaultView;
    var context = canvas.getContext('2d');
    if (!context) throw new Error('Scratch canvas context is unavailable');
    var coin = options.coin || null;
    var threshold = Math.min(0.95, Math.max(0.1, Number(options.threshold) || 0.5));
    var sampleStep = Math.max(1, Math.floor(Number(options.sampleStep) || 4));
    var devicePixelRatio = Math.min(2, Math.max(1, Number(options.devicePixelRatio) || (win && win.devicePixelRatio) || 1));
    var requestFrame = options.requestAnimationFrame || (win && win.requestAnimationFrame && win.requestAnimationFrame.bind(win)) || function (callback) { return setTimeout(callback, 16); };
    var cancelFrame = options.cancelAnimationFrame || (win && win.cancelAnimationFrame && win.cancelAnimationFrame.bind(win)) || clearTimeout;
    var onProgress = typeof options.onProgress === 'function' ? options.onProgress : function () {};
    var onStart = typeof options.onStart === 'function' ? options.onStart : function () {};
    var onComplete = typeof options.onComplete === 'function' ? options.onComplete : function () {};
    var listeners = [];
    var active = false;
    var started = false;
    var complete = false;
    var destroyed = false;
    var lastPoint = null;
    var coverageFrame = 0;
    var lastRatio = 0;
    var width = 1;
    var height = 1;
    var brushRadius = 16;

    function on(eventName, handler) {
      canvas.addEventListener(eventName, handler);
      listeners.push(function () { canvas.removeEventListener(eventName, handler); });
    }

    function drawFoil() {
      var bounds = canvas.getBoundingClientRect();
      width = Math.max(1, Math.round(bounds.width));
      height = Math.max(1, Math.round(bounds.height));
      brushRadius = Math.max(14, Math.min(24, width * 0.055));
      canvas.width = Math.round(width * devicePixelRatio);
      canvas.height = Math.round(height * devicePixelRatio);
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      context.scale(devicePixelRatio, devicePixelRatio);

      var foil = context.createLinearGradient(0, 0, width, height);
      foil.addColorStop(0, '#8f928b');
      foil.addColorStop(0.22, '#d4d6ce');
      foil.addColorStop(0.48, '#777a74');
      foil.addColorStop(0.72, '#c4c6bf');
      foil.addColorStop(1, '#686b65');
      context.fillStyle = foil;
      context.fillRect(0, 0, width, height);

      var shine = context.createLinearGradient(width * 0.05, height, width * 0.92, 0);
      shine.addColorStop(0, 'rgba(255,255,255,0)');
      shine.addColorStop(0.42, 'rgba(255,255,255,0.08)');
      shine.addColorStop(0.54, 'rgba(255,255,255,0.55)');
      shine.addColorStop(0.66, 'rgba(255,255,255,0.07)');
      shine.addColorStop(1, 'rgba(255,255,255,0)');
      context.fillStyle = shine;
      context.fillRect(0, 0, width, height);

      context.save();
      context.globalAlpha = 0.13;
      context.strokeStyle = '#ffffff';
      context.lineWidth = 0.7;
      for (var streak = 0; streak < 38; streak += 1) {
        var streakY = ((streak * 31) % height) + 0.5;
        context.beginPath();
        context.moveTo((streak * 17) % Math.max(1, width * 0.2), streakY);
        context.lineTo(width, Math.max(0, streakY - 8 - (streak % 5)));
        context.stroke();
      }
      context.globalAlpha = 0.32;
      for (var fleck = 0; fleck < 260; fleck += 1) {
        var fleckX = (fleck * 47 + fleck * fleck * 3) % width;
        var fleckY = (fleck * 29 + fleck * fleck * 5) % height;
        context.fillStyle = fleck % 5 === 0 ? '#3a3c38' : '#ffffff';
        context.fillRect(fleckX, fleckY, fleck % 7 === 0 ? 2 : 1, fleck % 11 === 0 ? 2 : 1);
      }
      context.restore();

      context.fillStyle = '#2e302d';
      context.font = '800 12px Manrope, Arial, sans-serif';
      context.textAlign = 'center';
      context.fillText('SCRATCH TO REVEAL', width / 2, height / 2 + 4);
      context.globalCompositeOperation = 'destination-out';
      context.lineCap = 'round';
      context.lineJoin = 'round';
      context.lineWidth = brushRadius * 2;
    }

    function point(event) {
      var bounds = canvas.getBoundingClientRect();
      return {
        x: Math.max(0, Math.min(width, Number(event.clientX) - bounds.left)),
        y: Math.max(0, Math.min(height, Number(event.clientY) - bounds.top))
      };
    }

    function moveCoin(position, isActive) {
      if (!coin || !position) return;
      coin.style.transform = 'translate3d(' + (position.x - 23) + 'px, ' + (position.y - 23) + 'px, 0) rotate(' + ((position.x + position.y) % 18 - 9) + 'deg)';
      coin.classList.toggle('is-active', Boolean(isActive));
    }

    function eraseDot(position, seed) {
      var wobbleX = Math.sin(seed * 2.17) * brushRadius * 0.36;
      var wobbleY = Math.cos(seed * 1.73) * brushRadius * 0.28;
      context.beginPath();
      context.arc(position.x, position.y, brushRadius, 0, Math.PI * 2);
      context.arc(position.x + wobbleX, position.y + wobbleY, brushRadius * 0.34, 0, Math.PI * 2);
      context.arc(position.x - wobbleY * 0.7, position.y + wobbleX * 0.55, brushRadius * 0.22, 0, Math.PI * 2);
      context.fill();
    }

    function measureCoverage() {
      coverageFrame = 0;
      if (destroyed) return lastRatio;
      try {
        lastRatio = alphaRatio(context.getImageData(0, 0, canvas.width, canvas.height), Math.max(1, Math.round(sampleStep * devicePixelRatio)));
      } catch (_error) {
        return lastRatio;
      }
      onProgress(lastRatio);
      if (!complete && lastRatio >= threshold) {
        complete = true;
        onComplete(lastRatio);
      }
      return lastRatio;
    }

    function scheduleCoverage() {
      if (coverageFrame || destroyed) return;
      coverageFrame = -1;
      var frame = requestFrame(measureCoverage);
      if (coverageFrame === -1) coverageFrame = frame;
    }

    function start(event) {
      if (destroyed) return;
      if (!started) {
        started = true;
        onStart();
      }
      active = true;
      lastPoint = point(event);
      moveCoin(lastPoint, true);
      eraseDot(lastPoint, 1);
      scheduleCoverage();
      if (canvas.setPointerCapture && event.pointerId !== undefined) {
        try { canvas.setPointerCapture(event.pointerId); } catch (_error) {}
      }
      if (event.cancelable) event.preventDefault();
    }

    function move(event) {
      if (!active || destroyed) return;
      var next = point(event);
      var dx = next.x - lastPoint.x;
      var dy = next.y - lastPoint.y;
      var distance = Math.sqrt(dx * dx + dy * dy);
      var steps = Math.max(1, Math.ceil(distance / Math.max(4, brushRadius * 0.42)));
      for (var index = 1; index <= steps; index += 1) {
        var progress = index / steps;
        eraseDot({ x: lastPoint.x + dx * progress, y: lastPoint.y + dy * progress }, index + next.x * 0.01);
      }
      lastPoint = next;
      moveCoin(next, true);
      scheduleCoverage();
      if (event.cancelable) event.preventDefault();
    }

    function stop() {
      active = false;
      lastPoint = null;
      if (coin) coin.classList.remove('is-active');
    }

    function ratio() {
      return measureCoverage();
    }

    function reveal() {
      if (complete || destroyed) return;
      if (!started) {
        started = true;
        onStart();
      }
      active = false;
      if (coin) coin.classList.remove('is-active');
      var rows = 6;
      var points = 22;
      for (var row = 0; row < rows; row += 1) {
        var startX = row % 2 === 0 ? width * 0.14 : width * 0.86;
        var endX = row % 2 === 0 ? width * 0.86 : width * 0.14;
        var baseY = height * (0.23 + (row / (rows - 1)) * 0.54);
        for (var index = 0; index < points; index += 1) {
          var progress = index / (points - 1);
          eraseDot({
            x: startX + (endX - startX) * progress,
            y: baseY + Math.sin(progress * Math.PI * 3 + row) * brushRadius * 0.18
          }, row * points + index + 7);
        }
      }
      measureCoverage();
      if (!complete) {
        complete = true;
        onComplete(lastRatio);
      }
    }

    function reset() {
      if (destroyed) return;
      complete = false;
      started = false;
      active = false;
      lastPoint = null;
      lastRatio = 0;
      if (coin) {
        coin.classList.remove('is-active');
        coin.style.transform = '';
      }
      drawFoil();
      onProgress(0);
    }

    function destroy() {
      if (destroyed) return;
      destroyed = true;
      listeners.splice(0).forEach(function (remove) { remove(); });
      if (coverageFrame > 0) cancelFrame(coverageFrame);
      coverageFrame = 0;
      if (coin) {
        coin.classList.remove('is-active');
        coin.style.transform = '';
      }
    }

    drawFoil();
    on('pointerdown', start);
    on('pointermove', move);
    on('pointerup', stop);
    on('pointercancel', stop);
    on('pointerleave', stop);

    return { reset: reset, reveal: reveal, destroy: destroy, ratio: ratio };
  }

  return { create: create, alphaRatio: alphaRatio };
});
